/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState, useCallback } from 'react';

import moment from 'moment';
import { shallowEqual, useSelector } from 'react-redux';

import { ReducerState as SocketReducerState } from '../global-states/socket';
import { ReducerState as SessionReducerState } from '../global-states/trip';
import {
  UPDATE_BUS_LIST,
  UPDATE_SCHEDULE_LIST,
  UPDATE_SOCKET,
  NewSocketMessageBus,
  ReducerState,
} from './reducer';
import socketClient from './socketClient';

function SocketHandler({
  socketState,
  socketDispatch,
}: {
  socketState: ReducerState;
  socketDispatch: React.Dispatch<any>;
}) {
  /** Props Constructions Section */
  const { trackingChannelId, tripDataIsLoading } = useSelector(
    ({
      trip,
      socket,
    }: {
      trip: SessionReducerState;
      socket: SocketReducerState;
    }) => ({
      tripData: trip.tripData?.trip,
      trackingChannelId: socket.trackingChannel,
      tripDataIsLoading: trip.tripDataState === 'loading',
    }),
    shallowEqual
  );

  const { socket, busList } = socketState;

  /** states sections */
  const [registeredEvent, setRegisteredEvent] = useState<string[]>([]);
  const [tempBus, setTempBus] = useState<NewSocketMessageBus | null>(null);

  const joinChannel = useCallback(() => {
    const timeout = setTimeout(() => {
      try {
        // @ts-ignore
        socket?.emit('join_channel', `${trackingChannelId}`);
        // socket?.emit('join_channel', `trip_${trackingChannelId}`);
      } catch (error) {
        console.log('join_channel', error) // eslint-disable-line
      }
    }, 555);

    return () => {
      clearTimeout(timeout);
    };
  }, [socket, trackingChannelId]);

  const leaveChannel = useCallback(() => {
    const timeout = setTimeout(() => {
      try {
        // @ts-ignore
        socket?.emit?.('leave_channel', `${trackingChannelId}`);
      } catch (error) {
        console.log('leave_channel', error) // eslint-disable-line
      }
    }, 555);

    return () => {
      clearTimeout(timeout);
    };
  }, [socket, trackingChannelId]);

  const resetData = useCallback(() => {
    socketDispatch({ type: `${UPDATE_BUS_LIST}_RESET` });
    socketDispatch({ type: `${UPDATE_SCHEDULE_LIST}_RESET` });
  }, [socketDispatch]);

  useEffect(() => {
    if (!socket) {
      socketDispatch({ type: UPDATE_SOCKET, payload: socketClient() });
    }
  }, [socket]); // eslint-disable-line

  useEffect(() => {
    let isSubscribed = true;
    const eventName = 'location_update';
    if (socket && !registeredEvent.includes(eventName)) {
      if (isSubscribed) setRegisteredEvent((prev: string[]) => [...prev, eventName]);
      // @ts-ignore
      socket?.registerHandler('connect', () => {
        // @ts-ignore
        socket?.registerHandler(eventName, (e: NewSocketMessageBus) => {
          // console.log('[SOCKET] data', e)
          setTempBus(e);
        });
      });
      // @ts-ignore
      socket?.registerHandler('disconnect', () => {
        // @ts-ignore
        socket?.deregisterHandler(eventName);
        // if (isSubscribed) setChannelIsJoined(false);
      });

      // @ts-ignore
      socket?.connect();
    }

    return () => {
      isSubscribed = false;
    };
  }, [socket]); // eslint-disable-line
  // console.log('trackingChannelId', trackingChannelId);

  useEffect(() => {
    if (!tempBus || !busList) return;

    const tempBusList = [...busList];
    const key = tempBusList.findIndex((b) => b.vehicleId === tempBus.vehicleId);
    let selectedTempBusItem: NewSocketMessageBus = {};

    if (key >= 0) {
      selectedTempBusItem = { ...tempBusList[key] };
      selectedTempBusItem.vehicleId = tempBus.vehicleId;
      if (tempBus.stopsList?.length === 0) {
        selectedTempBusItem.driverInfo = {
          latitude: tempBus?.driverInfo?.latitude,
          longitude: tempBus?.driverInfo?.longitude,
          speed: tempBus?.driverInfo?.speed,
          heading: tempBus?.driverInfo?.heading,
        };
        // selectedTempBusItem.lat = tempBus.lat
        // selectedTempBusItem.lng = tempBus.lng
        // selectedTempBusItem.sp = tempBus.sp
        // selectedTempBusItem.br = tempBus.br
      } else {
        // eslint-disable-next-line no-self-assign
        selectedTempBusItem.driverInfo = {
          latitude: tempBus.driverInfo?.latitude,
          longitude: tempBus.driverInfo?.longitude,
          speed: tempBus.driverInfo?.speed,
          heading: tempBus.driverInfo?.heading || 0,
          accuracy: tempBus?.driverInfo?.accuracy,
          altitude: tempBus?.driverInfo?.altitude,
        };
        // selectedTempBusItem.lat = tempBus.lat
        // selectedTempBusItem.lng = tempBus.lng
        // selectedTempBusItem.br = tempBus.br || 0
        // selectedTempBusItem.ns = tempBus.ns
        selectedTempBusItem.stopsList = [...(tempBus?.stopsList || [])];
        selectedTempBusItem.stopMapping = tempBus?.stopMapping;
        // selectedTempBusItem.em = [...tempBus.em]
        selectedTempBusItem.serverTimestamp = tempBus.serverTimestamp;
        selectedTempBusItem.version = tempBus?.version;
        // selectedTempBusItem.lockTimeStamp = moment().unix()
      }
      // selectedTempBusItem.timeout = 0
      // selectedTempBusItem.sl = tempBus.sl
      const tempBusList_ = [
        ...tempBusList.filter(
          (t) => t.vehicleId !== selectedTempBusItem?.vehicleId
        ),
        selectedTempBusItem,
      ];
      socketDispatch({ type: UPDATE_BUS_LIST, payload: tempBusList_ });
    } else {
      if (tempBus.stopsList?.length === 0) {
        tempBus.stopsList = [];
        // tempBus.ns = ''
      }
      if (!tempBus.serverTimestamp) {
        tempBus.serverTimestamp = moment().unix();
      }
      // tempBus.timeout = 0
      // tempBus.lockTimeStamp = moment().unix()
      tempBusList.push(tempBus);
      socketDispatch({ type: UPDATE_BUS_LIST, payload: tempBusList });
    }
  }, [tempBus]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(
    () => () => {
      if (tripDataIsLoading) {
        resetData();
      }
    },
    [tripDataIsLoading] // eslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(() => {
    if (trackingChannelId) {
      joinChannel();
    } else {
      leaveChannel();
    }
  }, [trackingChannelId]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}

export default SocketHandler;

export * from './_prototype';
